export default __webpack_public_path__ + "static/media/webBottom.94d17635.png";